import runtimeArt from './settlement-bridge-art.json';
import type { IslandQuad } from './settlement-island-registration';

const post = runtimeArt['timber-bridge-post-v1'];

/** Separate upright art: never send the whole post through a ground-plane projection. */
export const settlementBridgePostManifest = {
  id: 'settlement_timber_bridge_post_v1',
  ...post,
  anchor: { x: 627 / 1254, y: 1198 / 1254 },
  paintedHeight: 1175 / 1254,
  reviewStatus: 'needs_cultural_review',
} as const;

/** Sample only the unadorned front timber face for a rail's vertical side-plane material. */
export const settlementBridgeRailSource: IslandQuad = [
  { x: (680 / 1254) * post.width, y: (1080 / 1254) * post.height },
  { x: (680 / 1254) * post.width, y: (620 / 1254) * post.height },
  { x: (750 / 1254) * post.width, y: (620 / 1254) * post.height },
  { x: (750 / 1254) * post.width, y: (1080 / 1254) * post.height },
];
